import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { FormRulesTabPanel } from "@/features/form-editor/components/form-rules-tab-panel";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/recordTypes/$recordTypeId/full/form/rules",
)({
	component: FormRulesTabPanel,
	params: {
		parse: (raw) => {
			const p = raw as { orgId: string; recordTypeId: string };
			return {
				orgId: z.string().parse(p.orgId),
				recordTypeId: z.string().parse(p.recordTypeId),
			};
		},
	},
});
